import { supabase } from '@/lib/supabase';
import type { Business } from '../types';

/**
 * Fetch all businesses (for super admin use)
 */
export async function fetchBusinesses(): Promise<Business[]> {
  const { data, error } = await supabase
    .from('businesses')
    .select('id, name, default_currency, created_at, updated_at')
    .order('name', { ascending: true });

  if (error) {
    console.error('[businessesApi] Error fetching businesses:', error);
    throw new Error(error.message);
  }

  return data || [];
}

/**
 * Fetch a single business by ID
 */
export async function fetchBusinessById(businessId: string): Promise<Business | null> {
  const { data, error } = await supabase
    .from('businesses')
    .select('id, name, default_currency, created_at, updated_at')
    .eq('id', businessId)
    .single();

  if (error) {
    if (error.code === 'PGRST116') {
      // No rows returned
      return null;
    }
    console.error('[businessesApi] Error fetching business:', error);
    throw new Error(error.message);
  }

  return data;
}